import React, { useContext } from "react";

export type CardContextType = {
  onFollow?: () => void;
  onDelete?: () => void;
  onOpen?: () => void;
  onUpdate?: () => void;
  canUpdate?: boolean;
  isUpdating?: boolean;
  isFollowLoading?: boolean;
  isDeleteProcessing?: boolean;
};

export const CardContext = React.createContext(null as unknown as CardContextType);

type CardProviderProps = React.ProviderProps<CardContextType>;

export const CardProvider = ({ value, children }: CardProviderProps) => {
  return <CardContext.Provider value={value}>{children}</CardContext.Provider>;
};

export const useCardContext = () => {
  const context = useContext(CardContext);
  if (!context) {
    throw new Error("No context found for Card");
  }
  return context;
};
